import { makeStyles } from '@material-ui/core';

const usePeriodSelectorStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    gap: '20px'
  },
  periodSelect1: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '5px'
  },
  periodSelect2: {
    justifyContent: 'flex-start',
    display: 'flex',
    alignItems: 'center',
    width: '60%',
    gap: '5px'
  }
});

export default usePeriodSelectorStyles;
